module.exports = __webpack_public_path__ + "img/business-intelligence-big-data.6b25ad2e.webp";